/**
 * @file 任务创建-直播任务
 */

import { Modal } from '@seiue/ui'

import { EditTaskProps } from '../types'

import { EditLiveTaskModal } from './EditLiveTaskModal'

/**
 * 打开编辑直播任务弹窗
 *
 * @param param0 - 参数
 * @param param0.taskId - 任务 ID
 * @param param0.activityId - 活动 ID
 * @param param0.activityTaskOptions - 活动选项
 */
export const openEditLiveTask = ({
  activityId,
  taskId,
  activityTaskOptions,
}: EditTaskProps) => {
  const { hide } = Modal.open({
    header: null,
    footer: null,
    fullScreen: true,
    bodyStyle: { padding: 0 },
    children: (
      <EditLiveTaskModal
        onClose={() => {
          hide()
        }}
        taskId={taskId}
        activityId={activityId}
        activityTaskOptions={activityTaskOptions}
      />
    ),
  })
}
